/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sunny_Sunny_Toad_EmergeInputs */

const fr_sunny_sunny_toad_emerge = /** @type {(inputs: Sunny_Sunny_Toad_EmergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cet email sera utilisé pour les communications ainsi que la connexion au compte de
				l'utilisateur.`)
};

/**

* @param {Sunny_Sunny_Toad_EmergeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const sunny_sunny_toad_emerge = /** @type {((inputs?: Sunny_Sunny_Toad_EmergeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sunny_Sunny_Toad_EmergeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_sunny_sunny_toad_emerge(inputs)
});